import {Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Badge, Select, useDisclosure} from '@chakra-ui/react';
import { EmployeeModel } from '../../../../models/employee';
import React, { useState } from 'react';
import MyDiv from './myDepartmentList.style';
import { ChevronDownIcon } from '@chakra-ui/icons';
import AlertCard from "../../../../components/AlertCard"
import { useNavigate } from "react-router-dom";
import { CustomTable, CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from '../../../../components/CustomTable/customTable';

interface EmployeeListProps {
  employees: EmployeeModel[];
  statusDD: StatusDD[];
}
interface StatusDD {
  id: number;
  employeeStatus: string;
}

const MyDepartmentList: React.FC<EmployeeListProps> = ({ employees, statusDD }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeModel | null>(null);
  const navigate = useNavigate();
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [employeeStatuses, setEmployeeStatuses] = useState<Record<number, string>>(() => {
    const initialStatuses: Record<number, string> = {};
    employees.forEach(emp => {
      const match = statusDD.find(s => s.employeeStatus === emp.status);
      if (match) {
        initialStatuses[emp.id] = match.id.toString();
      }
    });
    return initialStatuses;
  });
  const [pendingStatus, setPendingStatus] = useState<string>('');
  const [pendingEmployeeId, setPendingEmployeeId] = useState<number | null>(null);

  const handleStatusChange = (emp: EmployeeModel, newStatus: string) => {
    setPendingStatus(newStatus);
    setPendingEmployeeId(emp.id);
    onOpen();
  };

  const handleConfirmStatusChange = async () => {
    if (!pendingEmployeeId || !pendingStatus) return;
    try {
      const payload = {
        employeeId: pendingEmployeeId,
        employeeStatusId: Number(pendingStatus),
      };
      const response = await fetchApi(
        `Hrlense_Employee/toggleEmpStatus/${pendingEmployeeId}`,
        "PUT",
        payload,
        "",
        ""
      );
      if (response?.success) {
        const updatedStatusName = statusDD.find(s => s.id.toString() === pendingStatus)?.employeeStatus;
        if (updatedStatusName) {
          setEmployeeStatuses(prev => ({
            ...prev,
            [pendingEmployeeId]: pendingStatus
          }));
          setTimeout(() => {
            addToast({ message: "Status updated successfully.", status: "success" });
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error updating employee status:", error);
      addToast({ message: "An error occurred while updating status.", status: "error" });
    }
    onClose();
  };



  return (
    <MyDiv>
      <Box className="table_wrapper" mt={2}>
        <CustomTable value={employees} emptyMessage="No Employees Found">
          <Column header="S. No" body={(_, index) => index + 1} />
          <Column
            header="Emp. ID"
            body={(emp:any) => (
              <Badge variant="subtle" className="empId font-poppins text_sm text_medium">
                {emp.empCode}
              </Badge>
            )}
          />
          <Column header="Name" field="name" />
          <Column header="Email" field="email" />
          <Column header="Company" body={(emp:any) => emp.usCompany || "Company Name"} />
          <Column header="Payroll Company" body={(emp:any) => emp.payrollCompany || "Company Name"} />
          <Column header="Branch" field="branch" />
          <Column header="Department" field="department" />
          <Column header="Designation" field="designation" />
          <Column header="Shift" field="shift" />
          <Column
             header="Status"
             body={(emp: any) => (
               <Select
                 isDisabled
                 value={employeeStatuses[emp.id]}
                 onChange={(e) => handleStatusChange(emp, e.target.value)}
                 className="font-poppins text_medium text_xsm"
                 width="78px"
                 height="24px"
                 icon={<ChevronDownIcon ml={2} />}
                 borderRadius="4px"
                 color={employeeStatuses[emp.id] === "Active" ? "#E53E3E" : "#38A169"}
                 sx={{ textAlign: "left", paddingLeft: "4px" }}
               >
                 {statusDD.map((status) => (
                   <option key={status.id} value={status.id}>
                     {status.employeeStatus}
                   </option>
                 ))}
               </Select>
             )}
           /> 
        </CustomTable>
      </Box>
      <AlertCard isOpen={isOpen} onClose={onClose} onConfirm={handleConfirmStatusChange} />
    </MyDiv>
  );
};

export default MyDepartmentList;
